import { Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import about_us from "../assets/Images/aboutus-2.jpg"
import shape from "../assets/Images/shapes/Thred 01-01.png"
import BookAppointmentDialog from './BookAnAppointmentDialogue'
export default function AboutBanner() {
  const [dialogOpen, setDialogOpen] = useState(false)
  const handleOpenDialog = () => {
    setDialogOpen(true)
  }
  const handleCloseDialog = () => {
    setDialogOpen(false)
  }
  return (
    <div>
      <div className='overflow-hidden'>
        <div className='pt-[48px] md:pt-[80px] lg:pt-[120px]'>
          <div className='max-w-[1340px] mx-auto relative'>
            <div className='relative z-[1] px-[24px]'>
              <div data-aos='fade-up' className='w-full lg:w-[1000px] mx-auto'>
                <div className='text-center mb-[56px] lg:mb-[64px] p-3 md:p-3 lg:p-0'>
                  <h1 className='text-[35px] md:text-[60px] lg:text-[74px] font-heading leading-[1.189em] mb-[32px] text-thickGreen'>
                    Compassionate Care with Advanced Technology for you
                  </h1>
                  <div className='sm:block md:flex justify-center md:space-x-4 space-y-4 md:space-y-0'>
                    <Link
                      to='#about-company'
                      className='border border-thickGreen  text-lightGreen px-7 py-6 rounded-full font-[300]  font-body text-[20px] leading-[1.112em] 
       transition-all duration-300 hover:bg-orange hover:text-white hover:border-none hover:bg-opacity-90 
       hover:translate-y-[-3px] block md:inline-block text-center mr-[0] md:mr-[24px]'
                      onClick={e => {
                        e.preventDefault()
                        document
                          .querySelector('#about-company')
                          ?.scrollIntoView({
                            behavior: 'smooth'
                          })
                      }}
                    >
                      Know About Us
                    </Link>
                    <button
                      onClick={handleOpenDialog}
                      className='text-white bg-orange px-12 py-5 rounded-full    md:flex justify-center items-center 
       hover:bg-thickGreen hover:border-none hover:text-white text-[20px] leading-[1.112em]  transition-all duration-300 hover:translate-y-[-3px] 
       block sm:inline-block text-center font-medium  font-body'
                    >
                      Book an Appointment
                    </button>
                  </div>
                </div>
              </div>
              <div
                data-aos='fade-up'
                className='flex flex-col justify-center items-center  lg:max-w-[1000px] w-full mx-auto'
              >
                <img
                  className='rounded-[24px] mb-[40px] md:mb-[64px]'
                  src={about_us}
                  alt='best doctors in hyderabad'
                  style={{
                    transform:
                      'translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                    transformStyle: 'preserve-3d',
                    opacity: 1
                  }}
                  loading='eager'
                />
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={{ xs: 6, lg: 16 }}>
                    <Grid
                      size={{ xs: 12, sm: 3, md: 3 }}
                      className='text-center'
                    >
                      <div className=' text-[60px] lg:text-[74px] font-heading leading-[1.189em]  text-thickGreen'>
                        10K<span className='text-orange'>+</span>
                      </div>
                      <div className='font-body font-medium text-[20px] leading-[1.1em] text-paraGreen'>
                        Happy Patients
                      </div>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 3, md: 3 }}
                      className='text-center'
                    >
                      <div className='text-[60px] lg:text-[74px] font-heading leading-[1.189em]  text-thickGreen'>
                        100<span className='text-orange'>+</span>
                      </div>
                      <div className='font-body font-medium text-[20px] leading-[1.1em] text-paraGreen'>
                        Team members
                      </div>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 3, md: 3 }}
                      className='text-center'
                    >
                      <div className='text-[60px] lg:text-[74px] font-heading leading-[1.189em]  text-thickGreen'>
                        500<span className='text-orange'>+</span>
                      </div>
                      <div className='font-body  font-medium text-[20px] leading-[1.1em] text-paraGreen'>
                        Positive reviews
                      </div>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 3, md: 3 }}
                      className='text-center'
                    >
                      <div className='text-[60px] lg:text-[74px] font-heading leading-[1.189em]  text-thickGreen'>
                        20<span className='text-orange'>+</span>
                      </div>
                      <div className='font-body font-medium text-[20px] leading-[1.1em] text-paraGreen'>
                        Strong Presence
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </div>
            <div className='absolute min-h-[47%] md:min-h-[57%] lg:min-h-[80%] top-[-48px] lg:top-[-110px] left-[20px] lg:left-[24px] right-[24px] rounded-[24px] bg-verylightGreen'></div>
            <div className='absolute inline-block w-[130%]  top-[16%] left-[-288px]'>
              <img
                src={shape}
                alt='shape'
              />
            </div>
          </div>
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
